/**
 * Sticky ATC (sht-prd-frm-sticky / .product__sticky-info)
 * Shows only once the reviews section (#brodeuses-reviews) reaches the viewport.
 * Theme default (reveal after main ATC) is disabled via data-is-enabled="false".
 */
(function () {
  var stickyEl = null;
  var reviewsEl = null;
  var footerEl = null;
  var ticking = false;

  function show() {
    if (!stickyEl) return;
    stickyEl.classList.add('opacity-1');
    stickyEl.classList.remove('hidden-xs', 'opacity-0');
  }

  function hide() {
    if (!stickyEl) return;
    stickyEl.classList.remove('opacity-1');
    stickyEl.classList.add('hidden-xs', 'opacity-0');
  }

  function update() {
    ticking = false;
    if (!stickyEl || !reviewsEl) return;

    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var viewportBottom = scrollY + window.innerHeight;
    var reviewsTop = reviewsEl.getBoundingClientRect().top + scrollY;

    // Reached reviews when the section enters the lower part of the viewport
    var reachedReviews = viewportBottom >= reviewsTop + 24;

    var nearFooter = false;
    if (footerEl) {
      var footerTop = footerEl.getBoundingClientRect().top + scrollY;
      nearFooter = viewportBottom >= footerTop + 8;
    }

    if (reachedReviews && !nearFooter) {
      show();
    } else {
      hide();
    }
  }

  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function init() {
    stickyEl = document.querySelector('.product__sticky-info');
    reviewsEl = document.getElementById('brodeuses-reviews');
    footerEl = document.querySelector('.js-footer');

    if (!stickyEl) return;

    // No reviews section: keep bar hidden (do not fall back to early theme reveal)
    if (!reviewsEl) {
      hide();
      return;
    }

    hide();
    update();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
